/* @flow */
import React from 'react';
import Transaction from 'entities/Transaction';
import TransactionAmount from 'payments/components/TransactionAmount.jsx';
import Money from 'payments/components/Money.jsx';
import Avatar from 'components/Avatar.jsx';
import Time from 'components/Time.jsx';

import 'payments/components/styles/TransactionsTableDepositRow.scss';

export default class TransactionsTableDepositRow extends React.Component {
  static propTypes = {
    transaction: React.PropTypes.instanceOf(Transaction),
  }

  render() {
    const { transaction } = this.props;

    return (
      <tr className="TransactionsTableDepositRow">
        <td colSpan={2}>
          <Avatar
            className="TransactionsTableDepositRow-droplet"
            color="grey"
            image={require('assets/images/payments/ic_deposit.svg')}
            size="small"
          />
          <span className="TransactionsTableDepositRow-depositTitle">
            You deposited{' '}<Money cents={transaction.getAmount()} />
          </span>
        </td>
        <td>
          <Time
            date={transaction.getCreatedAt()}
            day="numeric"
            month="short"
          />
        </td>
        <td>
          <TransactionAmount transaction={transaction} />
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/payments/components/TransactionsTableDepositRow.jsx